import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkTokenAndRedirect } from '../services/shopifyService';
import Loader from '../img/loader.gif'

const InstallPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    
    useEffect(() => {
        // Extract query parameters from the URL
        const urlParams = new URLSearchParams(location.search);
        const shop = urlParams.get('shop');

        if (shop) {
            checkTokenAndRedirect(shop, navigate);
        } else {
            // Handle case where shop parameter is missing
            console.log('Shop parameter is missing in the URL');
        }
    }, [location.search]);

    return <div style={{margin:'auto', display:'flex',justifyContent:'center',alignItems:'center'}}><img src={Loader} /></div>;
};

export default InstallPage;
